import { render, staticRenderFns } from "./setCoorSchedForYearSem.vue?vue&type=template&id=25b49782&"
import script from "./setCoorSchedForYearSem.vue?vue&type=script&lang=js&"
export * from "./setCoorSchedForYearSem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports